// Calls to the Ask HR API with the signed-in user's token. Errors keep the API's JSON body so
// pages can explain them (409 conflicts, "not configured", and so on).

import { apiToken } from "./auth/msal.js";

export class ApiError extends Error {
  constructor(
    readonly status: number,
    readonly body: { error?: string; [k: string]: unknown },
  ) {
    super(body.error ?? `HTTP ${status}`);
    this.name = "ApiError";
  }
}

export async function api<T>(method: string, path: string, body?: unknown): Promise<T> {
  const res = await fetch(path, {
    method,
    headers: {
      authorization: `Bearer ${await apiToken()}`,
      ...(body === undefined ? {} : { "content-type": "application/json" }),
    },
    ...(body === undefined ? {} : { body: JSON.stringify(body) }),
  });
  const json = (await res.json().catch(() => ({}))) as Record<string, unknown>;
  if (!res.ok) throw new ApiError(res.status, json);
  return json as T;
}
